import { useEffect, useState } from "react";
import Select from "react-select";
import ReactJsonView from "@microlink/react-json-view";
import API from "../../services/api";
import { languageOptions } from "../../utils/constants";
import { Toast } from "../../shared/Toast";

const typeOptions = [
    { value: "trending-share-data", label: "Trending Share Data" },
    { value: "classifieds", label: "Classifieds" },
    { value: "ads", label: "Ads" },
    { value: "custom", label: "Custom" },
];

const RedisObjects = () => {
    const [type, setType] = useState(typeOptions[0]);
    const [lang, setLang] = useState(languageOptions[0]);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [customKey, setCustomKey] = useState("");
    const [debouncedCustomKey, setDebouncedCustomKey] = useState("");

    const fetchRedisObjects = async () => {
        if (!type || !lang) {
            Toast("error", "PLEASE SELECT LANGUAGE AND TYPE");
            return;
        }

        setLoading(true);
        setError("");
        try {
            const result = await API({
                url: "/redis/getRedisObject",
                method: "POST",
                responseType: "json",
                data: {
                    type: type.value,
                    lang_id: lang.value,
                    key: debouncedCustomKey,
                },
            });

            setData(result.data);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch Redis object.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedCustomKey(customKey);
        }, 1500);

        return () => {
            clearTimeout(handler);
        };
    }, [customKey]);

    useEffect(() => {
        fetchRedisObjects();
    }, [type, lang, debouncedCustomKey]);

    return (
        <div className="p-6 max-w-6xl mx-auto">
            <h1 className="text-3xl font-bold mb-6 text-gray-800">Redis Object Viewer</h1>

            <div className="flex flex-col sm:flex-row gap-6 mb-8">
                <div className="flex-1">
                    <label className="text-sm font-semibold mb-2 block text-gray-600">Select Type</label>
                    <Select options={typeOptions} value={type} onChange={setType} className="react-select-container" classNamePrefix="react-select" />
                </div>
                <div className="flex-1">
                    <label className="text-sm font-semibold mb-2 block text-gray-600">Select Language</label>
                    <Select options={languageOptions} value={lang} onChange={setLang} className="react-select-container" classNamePrefix="react-select" />
                </div>
            </div>

            {type.value === "custom" && (
                <div className="mb-8">
                    <label className="text-sm font-semibold mb-2 block text-gray-600">Enter Key</label>
                    <input type="text" value={customKey} onChange={(e) => setCustomKey(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter custom key" />
                </div>
            )}

            {loading && <p className="text-blue-500 mb-4">Loading...</p>}
            {error && <p className="text-red-500 mb-4">{error}</p>}

            {data && (
                <div className="bg-white border shadow-md rounded-lg px-2 py-1 min-w-screen">
                    <div className="max-h-[650px]  overflow-auto">
                        <ReactJsonView src={data} theme={"monokai"} name={false} collapsed={1} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default RedisObjects;
